import React, { useEffect, useRef, useState } from 'react'
import HighchartsReact from 'highcharts-react-official'
import Highcharts from 'highcharts'
import HighchartsMore from 'highcharts/highcharts-more'

HighchartsMore(Highcharts)

const BoxAndWhiskerChartElement: React.FC<HighchartsReact.Props> = ({
  options,
}) => {
  const chartRef = useRef<HighchartsReact.RefObject>(null)
  const [height, setHeight] = useState<string | number | null | undefined>(null)
  const [chartOptions, setChartOptions] = useState(options)

  useEffect(() => {
    const chart = chartRef.current?.chart as any
    const container = chartRef.current?.container.current
    if (chart && container) {
      setChartOptions(options)
      setHeight(options?.chart?.height)
    }
  }, [options])

  return (
    <div style={height ? { height: `${height || 400}px` } : {}}>
      <HighchartsReact
        containerProps={{ style: { height: '100%' } }}
        ref={chartRef}
        highcharts={Highcharts}
        options={chartOptions}
      />
    </div>
  )
}

export default BoxAndWhiskerChartElement
